var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import _Handlebars2 from "../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import { loc, View, internal } from "../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import oktaJQueryStatic from "../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import FormController from "../util/FormController.js";
import FormType from "../util/FormType.js";
import FooterWithBackLink from "../views/shared/FooterWithBackLink.js";
let {
  Util
} = internal.util;
var VerifyPIVController = FormController.extend({
  className: "piv-cac-card",
  Model: {
    save: function() {
      return __async(this, null, function* () {
        this.trigger("request");
        const self = this;
        const pivConfig = this.settings.get("piv");
        const data = {
          fromURI: this.settings.get("relayState"),
          isCustomDomain: pivConfig.isCustomDomain,
          customDomain: pivConfig.customDomain
        };
        try {
          yield this.getCert(pivConfig.certAuthUrl);
          const res = yield this.postCert(pivConfig.certAuthUrl, data);
          Util.redirect(res.redirectUrl);
        } catch (err) {
          if (oktaUnderscore.isEmpty(err.responseJSON) && !err.responseText) {
            err.responseJSON = {
              errorSummary: loc("piv.cac.error", "login")
            };
          }
          self.trigger("error", self, err);
        }
      });
    },
    getCert: function(certAuthUrl) {
      return oktaJQueryStatic.get({
        url: certAuthUrl,
        xhrFields: {
          withCredentials: true
        },
        beforeSend: function() {
        }
      });
    },
    postCert: function(certAuthUrl, data) {
      return oktaJQueryStatic.post({
        url: certAuthUrl,
        xhrFields: {
          withCredentials: true
        },
        data: JSON.stringify(data),
        contentType: "text/plain",
        beforeSend: function() {
        }
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: oktaUnderscore.partial(loc, "piv.cac.title", "login"),
    className: "piv-cac-card",
    noCancelButton: true,
    save: oktaUnderscore.partial(loc, "retry", "login"),
    modelEvents: {
      request: "_startEnrollment",
      error: "_stopEnrollment"
    },
    formChildren: [FormType.View({
      View: View.extend({
        template: _Handlebars2.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return void 0;
            };
            return '<div class="piv-verify-text"><p>' + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "piv.cac.card.insert"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 32
                },
                "end": {
                  "line": 1,
                  "column": 82
                }
              }
            })) + '</p><div data-se="piv-waiting" class="okta-waiting-spinner"></div></div>';
          },
          "useData": true
        })
      })
    })],
    _startEnrollment: function() {
      this.$(".okta-waiting-spinner").show();
      this.$(".o-form-button-bar").hide();
    },
    _stopEnrollment: function() {
      this.$(".okta-waiting-spinner").hide();
      this.$(".o-form-button-bar").show();
    },
    postRender: function() {
      oktaUnderscore.defer(() => {
        this.model.save();
      });
    }
  },
  back: function() {
  },
  Footer: FooterWithBackLink
});
export { VerifyPIVController as default };
